import { Collection } from "./Collection";
import { Icons } from "./Icons";
import { ContainerAnima } from "./styles";

export function Anima() {
    return(
        <ContainerAnima>
            <h2>Anima Plasma Collection</h2>
            <div>
                <p className="subtitle">
                    SEASON 1
                </p>
                <div className="text-anima">
                    <p >
                        Discover our spring collection of helmets and bodysuits–tailored for the soul of the fractal travellers of Decentraland. 
                    </p>
                </div>
                <Icons/>
                <Collection />
            </div>
        </ContainerAnima>
    )
}